module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-seven.0344b91f.png";